const timeSummary = "/telecallers/timeSummary";
const digimrCallHistories = "/telecallers/histories";
const digimrProjectSumary = "/telecallers/project/summary";
const digimrBestCallStatus = "/telecallers/best-call-status";
const fieldMrReferralVerify = "/users/count";
const fieldMrReferralSummary = '/users/referred-by-fieldmrs';

export { timeSummary, digimrCallHistories, digimrProjectSumary, digimrBestCallStatus,fieldMrReferralVerify, fieldMrReferralSummary };
